import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../../context/PharmaciesDetailsFiltersContext'

const GET_OPEN_AFTER = gql`
  query PaymentReceivedOn($filters: NewOrderFilter) {
    pharmaciesAggs(
      size: 0
      filters: $filters
      aggs: { PagamentoEntrega: { terms: { field: "paymentReceivedOn" } } }
    ) {
      aggregations
    }
  }
`

const PaymentReceivedOn = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_OPEN_AFTER,
    {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { orderCreatedAt: filters.createdAt, ...omit(filters, 'createdAt') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  const isOn = data.pharmaciesAggs.aggregations.PagamentoEntrega?.buckets[0]?.key === 1 ? 'Sim' : 'Não'

  return (
    <CardWidget
      title="Pagamento na entrega"
      number={isOn}
      color={Colors.blue}
    />
  )
}

export default PaymentReceivedOn
